import { ReportType } from 'src/app/reports/interfaces/report.interface';
import { EnvironmentModel, Features } from 'src/environments/environmentModel';
import { NineboxFeature } from 'src/environments/features/ninebox.feature';
import { SsoFeature } from 'src/environments/features/sso.feature';
import { QuestionTypeEnum } from "../app/shared/interfaces/process-config.interface";
import { QuestionTypeAvailabilityFeature } from "./features/question-type-availability.feature";

const apiUrl = 'https://prod.performance.btg.api.btgpactual.com/backend';
const apiUrlTG4 = 'https://prod.performance.btg.api.tg4.com.br/backend';

export const environment: EnvironmentModel = {
    clientName: 'btg',
    production: true,
    apiUrl: apiUrl,
    apiUrlTG4: apiUrlTG4,
    logo: 'assets/imgs/logo2.svg',
    hideReports: false,
    azureAD: {
        clientId: '701fbf57-2dde-4a62-b4ef-48b934e14dd2',
        tenantId: '16e7cf3f-6af4-4e76-941e-aecafb9704e9',
        scope: 'api://701fbf57-2dde-4a62-b4ef-48b934e14dd2/TG4',
    },
    appflow: {
        appId: '6b1d38f3',
        channel: 'Production'
    },
    features: new Features({
        showDescriptionReport: true,
        reportsToHide: [ReportType.SelfEvaluationWithoutAnswers, ReportType.AllUsersReport, ReportType.AllEvaluationReport],
        sendLimitFinalEvaluationRule: true,
        hasGoalsInputOnSelfEval: true,
        highlightSelfOrManagerEvalAnswer: true,
        highlightSelfGoalsFinalGradeAnswer: true,
		frozenStructureEnabled: true,
		feedbackFeatureRefinement: true,
        reopenSelectionEnabled: true,
        typeConfigDescriptionEnabled: true,
        setPossibleValuesEndYearAsENTranslate: true,
        nineBox: new NineboxFeature({ enabled: true }),
        sso: new SsoFeature({ enabled: true, logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout?' }),
        questionTypeAvailability: new QuestionTypeAvailabilityFeature({
            [QuestionTypeEnum.Calculate]: {
                enabled: true,
                hidden: false
            }
        }),
        showCorePrinciples: true,
        isConsentGoalsEnabled: true,
        showUserAccessType: true,
        showDashboardWelcome: true,
        showPartnerCycleConfiguration: true,
        showNamedPromotionAndPriority: true,
        filterByGroupedAttributes: false,
        showThreeSixtyEvaluationLimit: true,
        aiReview: true,
        showNotifications: false,
        cannotOpenProfile: false,
		showSelectedCountOnSelection360: true,
        showSkipTwoPlusTwoCoachingEvaluation: false,
        principlesConfiguration: true,
        useTranslationOnOverallEvaluation: true,
    })
};
